import React from 'react'
import { Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import {
  Step,
  StepTitle,
  StepSubmitButton,
  StepOrderSummary,
} from '../../../../components'
import { formatAddressToExtended } from '../../../../utils'
import { ConfirmAddress } from '../../../../components/ConfirmAddress'
import type { ConfirmAddressInfo } from '../../../../components/ConfirmAddress'
import type { ClientDataAddress } from '../../../../typings'

export type ConfirmAddressStepProps = {
  isBusy?: boolean
  address: ClientDataAddress
  onStepSubmit?: () => void
  onEditAddressInfoClick?: (info: ConfirmAddressInfo) => void
}

export const ConfirmAddressStep = ({
  isBusy,
  address,
  onStepSubmit = () => {},
  onEditAddressInfoClick,
}: ConfirmAddressStepProps) => {
  return (
    <Step>
      <StepTitle>
        <FormattedMessage id="checkout.home-delivery.step.confirm-address.title" />
      </StepTitle>
      <Text
        variant="pageTitle"
        tone="secondary"
        className={csx({ display: 'block', marginTop: '$space-4' })}
      >
        {formatAddressToExtended(address)}
      </Text>
      <ConfirmAddress
        address={address}
        onEditInfoClick={onEditAddressInfoClick}
        className={csx({ marginTop: '$space-10', width: '100%' })}
      />
      <StepOrderSummary>
        <StepSubmitButton
          disabled={isBusy}
          loading={isBusy}
          onClick={onStepSubmit}
        >
          <FormattedMessage id="continue" />
        </StepSubmitButton>
      </StepOrderSummary>
    </Step>
  )
}
